import Vue from 'vue'
import VueRouter from 'vue-router'


// 引入组件
const home = () => import('@/views/HomePage.vue')
const news = () => import('@/views/NewsPage.vue')
const newsdetail = () => import('@/views/NewsDetails.vue')
const showProduct = () => import('@/views/ShowProductPage.vue')
const Cooperative = () => import('@/views/CooperativePage.vue')
const contactUs = () => import('@/views/ContactUsPage.vue')
const aboutUs = () => import('@/views/AboutUsPage.vue')
const ProductDetail = () => import('@/views/ShowProduct/ProductDetail.vue')
const IntroDuction = () => import('@/views/ShowProduct/IntroDuction.vue')
const empty = () => import('@/views/empty.vue')


Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push;
 
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  {
    path:'/',
    // redirect 重定向
    redirect:'/home'
  },
  {
    path:'/home',
    component:home
  },
  {
    path:'/news',
    component:news
  },
  {
    path:'/newsdetails',
    component:newsdetail
  },
  {
    path:'/showProduct',
    component:showProduct
  },
  {
    path:'/Cooperative',
    component:Cooperative
  },
  {
    path:'/contactUs',
    component:contactUs
  },
  {
    path:'/aboutUs',
    component:aboutUs
  },
  {
    path:'/empty',
    component:empty
  },
//   {
//     path:'/ProductDetail',
//     component:()=>import('@/views/ShowProduct/ProductDetail.vue')
// },
  {
    path:'/ProductDetail',
    component:ProductDetail,
    // beforeEnter: (to, from, next) => {
    //   console.log(to.query)
    //   next()
    // }
  },
  // {
  //   // /search/screens -> /search?q=screens
  //   path: '/ProductDetail/:words',
  //   redirect: to => {
  //     // 方法接收目标路由作为参数
  //     // return 重定向的字符串路径/路径对象
  //     // console.log("word",to.params.words )
  //     return { path: '/ProductDetail', query: { words: to.params.words } }
   
  //   },
  // },
  {
    path:'/introduction',
    component:IntroDuction
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  routes,
  mode:"history",
  base: "/web/"
})

export default router
